import React from 'react'


const Payment = () => {



   
  return (
    <div className='conatiner' style={{height:"80vh"}}>

        <h2>Your order has been successfully placed</h2>
      
    </div>
  )
}

export default Payment
